/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});

    const quickAddForm = document.querySelectorAll('.quickAddForm');
    const atcAlert = document.querySelector('.atcAlert');
    const atcAlertInner = document.querySelector('.atcAlertInner');
    quickAddForm.forEach(function(el, i) {
      let qtyInput = el.querySelector('.quickAddFormQty');
      let idInput = el.querySelector('.quickAddFormID');
      let nameInput = el.querySelector('.quickAddFormName');
      let counter = el.querySelector('.quickAddFormCounter');
      let btnDecr = el.querySelector('.btnDecr');
      let btnInc = el.querySelector('.btnInc');
      let btnSubmit = el.querySelector('.btnSubmit');

      btnDecr.addEventListener('click', function() {
        let currQty = Number(qtyInput.value);
        console.log(currQty);
        if (currQty > 1) {
          let calcQty = currQty - 1;
          qtyInput.value = calcQty;
          counter.innerHTML = calcQty + '•';
          if (calcQty == 1) {
            counter.innerHTML = '';
          }
        }
      });

      btnInc.addEventListener('click', function() {
        let currQty = Number(qtyInput.value);
        let calcQty = currQty + 1;
        qtyInput.value = calcQty;
        counter.innerHTML = calcQty + '•';
      });

      btnSubmit.addEventListener('click', function(e) {
        e.preventDefault();
        let id = idInput.value;
        let qty = qtyInput.value;
        let name = nameInput.value;
        fetch('/cart/add.js', {
          body: JSON.stringify({id: id, quantity: qty}),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          }
        }).then(function (response) {
          if (response.ok) {
            let statusText = 'איזה כייף לך! הוספנו ' + qty.toString() + ' ' + name + ' לסל שלך';
            atcAlertInner.innerHTML = statusText;
            atcAlert.classList.add('show');
            setTimeout(() => {
              atcAlert.classList.remove('show');
              atcAlertInner.innerHTML = '';
            }, 10000);
          } else {
            
          }
        });
      });
    });
  })();